import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/straight-line-depreciation-calculator',
  component: () => import('../../routes/StraightLineDepreciationCalculator.svelte'),
  card: {
    id: 'straight-line-depreciation',
    title: 'Straight-Line Depreciation',
    description: 'Calculate annual depreciation expense using the straight-line method with IRS half-year convention.',
    icon: 'straighten',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/straight-line-depreciation-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Straight-Line Depreciation Calculator – IRS Half-Year Convention',
    description:
      'Free straight-line depreciation calculator. Calculate annual depreciation, book value schedule, and accumulated depreciation using IRS half-year convention for business assets.',
  },
};

export default meta;
